module.exports = __webpack_public_path__ + "img/logo-elha.5da4b600.png";